export default __webpack_public_path__ + "static/media/r8.efdf4d2b.jpeg";